import type { Clip } from './supabase';

// Upload flows (web + mobile) write these defaults when the player types
// nothing, so they carry no meaning and shouldn't be shown as a caption.
const PLACEHOLDER_TITLE = /^(gameplay )?clip( \d+)?$/i;
const PLACEHOLDER_DESCRIPTIONS = new Set([
  'profile clip',
  'uploaded clip',
  'uploaded from wizard',
]);

/** The clip's real caption (title and/or description), or '' if it only has upload defaults. */
export function clipCaption(clip: Pick<Clip, 'title' | 'description'>): string {
  const title = clip.title?.trim() ?? '';
  const description = clip.description?.trim() ?? '';
  const parts: string[] = [];
  if (title && !PLACEHOLDER_TITLE.test(title)) parts.push(title);
  if (description && !PLACEHOLDER_DESCRIPTIONS.has(description.toLowerCase())) {
    parts.push(description);
  }
  return parts.join(' · ');
}
